const months = [
    'Muharram',
     'Safar',
     'Rabi\' al-Awwal'
    , 'Rabi\' al-Thani'
    , 'Jumada al-Ula'
    , 'Jumada al-Alkhirah'
    , 'Rajab'
    , 'Sha’ban'
    , 'Ramadhan'
    , 'Shawwal'
    , 'Thul-Qi’dah'
    , 'Thul-Hijjah'
]

const monthsShort = [
    'Muh'
    , 'Saf'
    , 'Rab-I'
    , 'Rab-II'
    , 'Jum-I'
    , 'Jum-II'
    , 'Raj'
    , 'Sha'
    , 'Ram'
    , 'Shw'
    , 'Dhu-Q'
    , 'Dhu-H'
]

export default {
    name: 'en_hijri',
    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    months,
    monthsShort,
    week: {
        dow: 5
    }
}
